import { useTranslation } from "react-i18next";
import { useParams, Navigate } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { SectionReveal } from "@/components/shared/SectionReveal";

const VALID_PAGES = ["mentions", "cgu", "cookies"];

export default function Legal() {
  const { t } = useTranslation();
  const { lang = "fr", page } = useParams();

  if (page === "privacy") return <Navigate to={`/${lang}/legal/mentions`} replace />;
  if (!VALID_PAGES.includes(page)) return <Navigate to={`/${lang}/legal/mentions`} replace />;

  const data = t(`legal.${page}`, { returnObjects: true });

  return (
    <div data-testid={`legal-page-${page}`}>
      <SEO title={`${data.title} — Fastority`} description={data.title} path={`legal/${page}`} />
      <section className="py-24 sm:py-28 bg-offwhite min-h-[60vh]">
        <SectionReveal className="max-w-2xl mx-auto px-5 sm:px-8">
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight text-slate900 mb-8">{data.title}</h1>
          <div
            className="prose prose-slate text-slate-700 leading-relaxed [&_p]:mb-4 [&_h2]:text-xl [&_h2]:font-heading [&_h2]:font-bold [&_h2]:text-slate900 [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:text-base [&_h3]:font-heading [&_h3]:font-bold [&_h3]:text-slate900 [&_h3]:mt-6 [&_h3]:mb-2"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </SectionReveal>
      </section>
    </div>
  );
}
